import { request } from './api';
import { IUser } from '@ui/api/v2/user.api';

interface ICountry {
  id: number;
  name: string;
}

export interface IFactory {
  id: number;
  name: string;
  country: ICountry;
}

export interface ICreateFactory {
  name: string;
  country: string;
}

export interface IStore {
  id: number;
  name: string;
  address: string;
  phone: string;
  firstName: string;
  lastName: string;
  firstContactPhone: string;
  secondContactPhone: string;
  lastRequest: {
    id: number;
    status: 'success' | 'fail';
    updated: string;
    user: IUser;
  };
  photo: string;
}

export function getReportStores(regionId?: string, cityId?: string, marketId?: string) {
  return request<IStore[]>('get', '/store/report', { regionId, cityId, marketId });
}

export function updateReference(storeId: string, collectionIdsToAdd: string[], collectionIdsToDelete: string[]) {
  return request('patch', `store/${storeId}/update-reference`, {
    collectionsToAdd: collectionIdsToAdd,
    collectionsToDelete: collectionIdsToDelete,
  });
}

export function getFactories() {
  return request<IFactory[]>('get', 'store/factories-admin');
}

export function createFactory(factory: ICreateFactory) {
  return request<IFactory>('post', 'store/factories-admin', { factory });
}

export function updateFactory(id: number, factory: ICreateFactory) {
  return request<IFactory>('patch', `store/factories-admin/${id}`, { factory });
}

export function deleteFactory(id: number) {
  return request<IFactory>('delete', `store/factories-admin/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/v2/store.api.ts